"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable no-unused-vars */

exports.default = {
    rules: {
        2514541: function _(region) {
            return false;
        }, //drop Cirpus
        3263728: function _(region) {
            return false;
        }, //drop Cirpus
        3263726: function _(region) {
            return false;
        }, //drop Cirpus

        2088990: function _(region) {
            return false;
        }, //drop Kosovo

        192691: function _(region) {
            return region.hasParent(192691) || region.osmId == 195838;
        }, //move EH to MA
        195838: function _(region) {
            return false;
        }, //drop EH

        1152720: function _(region) {
            return false;
        }, //drop Ab
        1152717: function _(region) {
            return false;
        }, //drop Oset

        270056: function _(region) {
            return region.hasParent(270056) || region.osmId == 449220;
        }, //move TW to CN
        449220: function _(region) {
            return false;
        } //drop TW
    }
};